import React from 'react';
import { Link } from 'react-router-dom';
import { treeRegistry } from '../config/treeRegistry';
import Diamond from './Diamond';

// Filter out trees that shouldn't appear in the public Arcade
// Map tree IDs to URL slugs
const arcadeTrees = treeRegistry
  .filter(tree => tree.id !== 'location')
  .map(tree => ({
    ...tree,
    // Map internal IDs to URL-friendly slugs
    slug: tree.id === 'mini' ? 'intro' : tree.id
  }));

const ArcadeSection = () => {
  return (
    <section className="arcade-section" id="arcade" data-testid="arcade-section">
      <span className="ghost-number arcade-ghost">08</span>
      <div className="arcade-container">
        {/* Section Header */}
        <div className="arcade-header">
          <span className="arcade-label">THE ARCADE</span>
          <h2 className="arcade-heading">
            <span className="headline-bold">Play the trees.</span>{' '}
            <span className="headline-light">Walk through any decision.</span>
          </h2>
          <p className="arcade-subheading">
            These are real decision trees built during Binary Game sessions. 
            Walk through them interactively or view the full structure.
          </p>
        </div>

        {/* Tree Grid */}
        <div className="arcade-grid">
          {arcadeTrees.map((tree) => (
            <div key={tree.id} className="arcade-card" data-testid={`arcade-card-${tree.id}`}>
              <div className="arcade-card-header">
                <span className="arcade-card-category">{tree.category}</span>
                <span className="arcade-card-gates">{tree.gates} GATES</span>
              </div>
              
              <h3 className="arcade-card-title">{tree.title}</h3>
              <p className="arcade-card-description">{tree.description}</p>
              
              <div className="arcade-card-actions">
                <Link
                  to={`/tree/${tree.slug}`}
                  className="arcade-btn arcade-btn-primary arcade-btn-full"
                  data-testid={`arcade-walkthrough-${tree.id}`}
                >
                  <Diamond color="#FFFFFF" size="xs" />
                  Walk Through
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArcadeSection;
